import { render, staticRenderFns } from "./TestOrderModal.vue?vue&type=template&id=8599bb60"
import script from "./TestOrderModal.vue?vue&type=script&lang=js"
export * from "./TestOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports